import React, { Component } from 'react';
import { Button, Popover } from 'antd';
import auth from '@root/service/auth-manager';
import ChangePwd from './Modal/changePwd';
import cookies from 'js-cookie';
import notification from '@root/components/Notification/index';
// import BgInit from './bg'
import Weather from './weather';
import moment from 'moment';
import classnames from 'classnames';
import { _CITY_, logoImg } from 'udian-tob-lib';
import ZhuyunLogin from '@root/service/zhuyunLogin';
import './portal.scss';

auth.init(process.env.BUILD_TO);

const logo = logoImg;

const AMap = window.AMap;
// console.log('=====',logoImg)
const WEEKDATA = ['日', '一', '二', '三', '四', '五', '六'];
const _PADDING = 20;
const defaultWeather = {
  weatherType: 'sunny',
  temperature: 18,
  icon: 'udian-qing',
};
// const citydata = ['咸宁','深圳','上栗','盘州','藤县']

export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BASE: 80,
      hovered: false,
      showPwd: false,
      current: {
        time: moment().format('HH:mm'),
        date: moment().format('YYYY/MM/DD'),
        week: WEEKDATA[new Date().getDay()],
      },
      weather: defaultWeather,
    };
    this._resize = this._resize.bind(this);
    this.menus = {};
    this.userName = auth._userInfo && auth._userInfo.name;
    this.disabledCheck = this.disabledCheck.bind(this);
    this.timer = null;
    this.map = null;
    // this.bgImg = require('@root/assets/images/noon.png')
  }

  /**
   *
   * @param {*} w width
   * @param {*} h height
   * @param {*} l left
   * @param {*} t top
   * @param {*} lp 补充left
   * @param {*} tp 补充top
   * @param {*} aW 补充width
   * @param {*} aH 补充height
   */
  _style(w, h, l, t, lp = 0, tp = 0, aW = 0, aH = 0) {
    const { BASE } = this.state;
    return {
      width: BASE * w + aW + 'px',
      height: BASE * h + aH + 'px',
      left: BASE * l + lp * _PADDING + 'px',
      top: BASE * t + tp * _PADDING + 'px',
    };
  }

  async componentWillMount() {
    console.log(cookies.get('token'));
    if (!cookies.get('token')) {
      auth.toLoginPage();
      return;
    }
    this.menus = await auth.getMenu();
    this._resize();
    window.addEventListener('resize', this._resize);
    this.timer = setInterval(() => {
      const current = moment(),
        time = current.format('HH:mm'),
        time2 = current.format('HH:mm:ss');
      this.setState({
        current: {
          time: time,
          date: current.format('YYYY/MM/DD'),
          week: WEEKDATA[current.weekday()],
        },
      });
      // 到点刷新
      if (
        time2 === '06:00:00' ||
        time2 === '10:00:00' ||
        time2 === '12:00:00' ||
        time2 === '18:00:00' ||
        time2 === '15:00:00' ||
        time2 === '20:00:00'
      ) {
        this.getWeather();
      }
    }, 1000);
  }

  componentDidMount() {
    // 背景动效
    // BgInit()
    setTimeout(() => {
      this.map = new AMap.Map('map', {
        resizeEnable: true,
        center: [116.486409, 39.921489],
        zoom: 12,
      });
      this.getWeather();
    }, 200);
  }

  getWeather = () => {
    AMap.plugin('AMap.Weather', () => {
      var weather = new AMap.Weather();
      //  citydata  _CITY_.cityName
      weather.getLive(_CITY_.cityName, (err, data) => {
        if (!err) {
          data.icon = 'udian-qing';
          data.weatherType = 'sunny';
          const weatherTime = this.judgeTimeDate();
          if (data.weather.indexOf('晴') > -1) {
            data.weatherType = 'sunny';
            data.icon = 'udian-qing';
          } else if (data.weather.indexOf('雨') > -1) {
            data.weatherType = 'rain';
            data.icon = 'udian-yu';
          } else if (data.weather.indexOf('雪') > -1) {
            data.weatherType = 'snow';
            data.icon = 'udian-xue';
          } else if (data.weather === '多云') {
            data.weatherType = 'cloud';
            data.icon = 'udian-yintian';
          } else {
            data.weatherType = 'dull';
            data.icon = 'udian-yintian';
          }
          // 晚上没有太阳和多云
          if (weatherTime === 'night' && data.weatherType === 'cloud') {
            data.weatherType = 'dull';
            data.icon = 'udian-yintian';
          }
          if (weatherTime === 'night' && data.weatherType === 'sunny') {
            data.icon = 'udian-yintian';
          }
          // console.log('=====', data)
          // cloud  3、 rain 100、snow 200
          new Weather({
            id: 'canvas1',
            weatherType: data.weatherType,
            num: data.weatherType === 'cloud' ? 1 : 100,
          });
          localStorage.setItem('weather', JSON.stringify(data));
          this.setState({
            weather: data,
          });
        } else {
          let weather = localStorage.getItem('weather');
          if (weather) {
            weather = JSON.parse(weather);
          } else {
            weather = defaultWeather;
          }
          this.setState({
            weather,
          });
        }
      });
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
    clearInterval(this.timer);
  }

  // 天气背景，晴天分早中晚，非晴天分白天和晚上，共5张背景图片
  weatherBg = () => {
    const { weather } = this.state;
    let weatherType = 'dull';
    if (weather.weatherType === 'sunny' || weather.weatherType === 'cloud') {
      weatherType = weather.weatherType;
    }
    return weatherType + '_' + this.judgeTimeDate();
  };

  // 判断时间段
  judgeTimeDate = () => {
    const hour = moment().hour();
    let timeType = 'night';
    if (hour < 6) {
      timeType = 'night';
    } else if (hour < 10) {
      timeType = 'morning';
    } else if (hour < 18) {
      timeType = 'noon';
    }
    return timeType;
  };

  handleHoverChange = (visible) => {
    this.setState({
      hovered: visible,
      clicked: false,
    });
  };

  _resize() {
    const cHeight = document.documentElement.clientHeight;
    let BASE = 80;
    if (cHeight < 880) BASE = 70;
    if (cHeight < 770) BASE = 60;
    if (cHeight < 640) BASE = 50;
    this.setState({ BASE });
  }

  handleGoto = (code, isDevelop = true) => {
    if (code && this.menus.has(code)) {
      window.open(window.location.protocol + '//' + this.menus.get(code).domain);
    } else {
      if (!isDevelop) return notification.info('功能待开发，敬请期待！');
      notification.info('你没有该系统权限');
    }
  };

  disabledCheck(code) {
    if (this.menus && JSON.stringify(this.menus) !== '{}' && !this.menus.has(code)) {
      return true;
    }
    return false;
  }

  renderDiffColumn = (system, name, subName, cls) => {
    return (
      <li
        className="item7"
        disabled={false}
        onClick={() => this.handleGoto(system)}
        style={this._style(3, 2, 4, 3, 2, 1, 0, -_PADDING)}
      >
        <div className="inner_box bg7">
          {/* <i className={`udianfont ${cls}`}></i> */}
          <div className="text_box">
            <p className="text_cn">{name}</p>
            <p className="text_en">{subName}</p>
          </div>
        </div>
      </li>
    );
  };

  render() {
    const { BASE, showPwd, current, weather } = this.state;

    const hoverContent = (
      <div className="change_pwd_popover">
        <p>用户{this.userName}，您好^_^ </p>
        <Button
          className="change_pwd_btn"
          type="primary"
          onClick={() => this.setState({ showPwd: true })}
        >
          修改密码
        </Button>
      </div>
    );
    return (
      <div className="portal_page">
        <div id="container" className="container portal_bg_container">
          <div id="output" className="container"></div>
        </div>
        <div className="portal_container">
          <header className="portal_head">
            <img className="logo_img" src={logo} alt="logo" />
            <div className="nav">
              <Popover
                style={{ width: 500 }}
                content={hoverContent}
                trigger="hover"
                placement="bottom"
                visible={this.state.hovered}
                onVisibleChange={this.handleHoverChange}
              >
                <span className="udianfont user_icon"></span>
                <span className="user_name">{this.userName}</span>
                {/* <i className="user_icon udianfont udian-user"></i> */}
              </Popover>
              <Button
                icon="poweroff"
                onClick={() => {
                  ZhuyunLogin.passportloginout();
                }}
                className="exit"
              >
                退出
              </Button>
            </div>
          </header>
          <ul className="portal_main">
            <section
              className="section_left"
              style={{ width: 5 * BASE + _PADDING, height: 8 * BASE + _PADDING * 2 }}
            >
              <li
                className={classnames('weather_box', this.weatherBg())}
                style={this._style(2, 6, 0, 0, 0, 0, 0, _PADDING)}
              >
                {/* <img src={this.bgImg} alt="bg" /> */}
                <canvas width="190" height="500" id="canvas1"></canvas>
                <div className="text_box">
                  <span className="degree">{weather.temperature}°</span>
                  <div className="weather">
                    <i className={`udianfont ${weather.icon}`}></i>
                    <span className="city">{_CITY_.spelling}</span>
                  </div>
                  <div className="time">
                    <p style={{ fontSize: '30px' }}>{current.time}</p>
                    <p>星期{current.week}</p>
                    <p>{current.date}</p>
                  </div>
                </div>
              </li>
              <li
                className="item1"
                disabled={this.disabledCheck('resource')}
                onClick={() => this.handleGoto('resource')}
                style={this._style(3, 3, 2, 0, 1, 0)}
              >
                <div className="inner_box bg1">
                  <div className="text_box">
                    {/* <i className="udianfont udian-portaltubiao-8"></i> */}
                    <p className="text_cn">基础数据系统</p>
                    <p className="text_en">basic Data System</p>
                  </div>
                </div>
              </li>
              <li
                className="item2"
                disabled={this.disabledCheck('vehicle')}
                onClick={() => this.handleGoto('vehicle')}
                style={this._style(3, 3, 2, 3, 1, 1)}
              >
                <div className="inner_box bg2">
                  <div className="text_box">
                    {/* <i className="udianfont udian-portaltubiao-3"></i> */}
                    <p className="text_cn">车辆管理系统</p>
                    <p className="text_en">vehicle management system</p>
                  </div>
                </div>
              </li>
              <li
                className="item3"
                disabled={this.disabledCheck('authority')}
                onClick={() => this.handleGoto('authority')}
                style={this._style(5, 2, 0, 6, 0, 2, _PADDING, 0)}
              >
                <div className="inner_box bg3">
                  {/* <i className="udianfont udian-portaltubiao-1"></i> */}
                  <div className="text_box">
                    <p className="text_cn">权限管理系统</p>
                    <p className="text_en">permission management system</p>
                  </div>
                </div>
              </li>
            </section>
            <section
              className="section_right"
              style={{ width: 7 * BASE + _PADDING * 2, height: 8 * BASE + _PADDING * 2 }}
            >
              <li
                className="item4"
                disabled={this.disabledCheck('statistics')}
                onClick={() => this.handleGoto('statistics')}
                style={this._style(4, 2, 0, 0, 0, 0, _PADDING)}
              >
                <div className="inner_box bg4">
                  {/* <i className="udianfont udian-portaltubiao-7"></i> */}
                  <div className="text_box">
                    {/* <p className="text_cn">决策分析系统</p>
                                        <p className="text_en">decision analysis system</p> */}
                    <p className="text_cn">营运统计系统</p>
                    <p className="text_en">operations statistics system</p>
                  </div>
                </div>
              </li>
              <li
                className="item5"
                disabled={this.disabledCheck('fdis')}
                onClick={() => this.handleGoto('fdis')}
                style={this._style(4, 3, 0, 2, 0, 1, _PADDING, -_PADDING)}
              >
                <div className="inner_box bg5">
                  {/* <i className="udianfont udian-portaltubiao-2"></i> */}
                  <div className="text_box">
                    <p className="text_cn">调度管理系统</p>
                    <p className="text_en">dispatch management system</p>
                  </div>
                </div>
              </li>
              <li
                className="item6"
                disabled={this.disabledCheck('bigdata')}
                onClick={() => this.handleGoto('bigdata')}
                style={this._style(3, 3, 4, 0, 2, 0)}
              >
                <div className="inner_box bg6">
                  {/* <i className="udianfont udian-portaltubiao-8"></i> */}
                  <div className="text_box">
                    <p className="text_cn">报表系统</p>
                    <p className="text_en">reporting system</p>
                  </div>
                </div>
              </li>
              {_CITY_.city === 'shenzhen'
                ? this.renderDiffColumn(
                    'safety',
                    '安全管控系统',
                    'safety management system',
                    'udian-weibiaoti--1'
                  )
                : _CITY_.city === 'xianning'
                ? this.renderDiffColumn(
                    'psafety',
                    '安全管控系统',
                    'safety management system',
                    'udian-weibiaoti--1'
                  )
                : this.renderDiffColumn(
                    'video',
                    '视频监测系统',
                    'video monitoring system',
                    'udian-portaltubiao-6'
                  )}
              {/* <li className="item10" disabled={this.disabledCheck('arrange')} onClick={()=>this.handleGoto('arrange')} style={this._style(7, 1, 0, 5, 0, 1, _PADDING * 2)}>
                                <div className="inner_box">
                                    <i className="udianfont udian-portaltubiao-4"></i>
                                    <div className="text_box">
                                        <p className="text_cn">自动排班系统</p>
                                        <p className="text_en">Scheduling system</p>
                                    </div>
                                </div>
                            </li> */}
              <li
                className="item8"
                disabled={this.disabledCheck('passenger')}
                onClick={() => this.handleGoto('passenger')}
                style={this._style(3, 3, 0, 5, 0, 1, _PADDING, _PADDING)}
              >
                <div className="inner_box bg8">
                  {/* <i className="udianfont udian-portaltubiao-5"></i> */}
                  <div className="text_box">
                    <p className="text_cn">线网客流系统</p>
                    <p className="text_en">Network planning system</p>
                  </div>
                </div>
              </li>
              <li
                className="item9"
                disabled={this.disabledCheck('arrange')}
                onClick={() => this.handleGoto('arrange')}
                style={this._style(4, 3, 3, 5, 2, 1, 0, _PADDING)}
              >
                <div className="inner_box bg9">
                  {/* <i className="udianfont udian-portaltubiao-4"></i> */}
                  <div className="text_box">
                    <p className="text_cn">自动排班系统</p>
                    <p className="text_en">Scheduling system</p>
                  </div>
                </div>
              </li>
            </section>
          </ul>
          <footer className="login_foot">
            <div className="udian_footer_copy">
              滴滴优点科技（深圳）有限公司 Copyright&#169;2016-
              {new Date().getFullYear()}&nbsp;
              <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                粤ICP备17071394号-1
              </a>
            </div>
          </footer>
        </div>
        <ChangePwd
          visible={showPwd}
          {...this.props}
          handleHide={() => {
            this.setState({ showPwd: false });
          }}
        />
        <div id="map"></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Portal/portal.js